module.exports = __webpack_public_path__ + "static/media/truck_new.252f4700.jpg";